import { makeStyles } from '@material-ui/core/styles'
import Background from '../../../assets/images/background.png'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: 'transparent',
    border: '1px solid #fff',
    color: '#fff'
  },
  password: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: 'transparent',
    border: '1px solid #fff',
    marginTop: '4.5%'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    color: '#000',
    backgroundColor: '#e8f0fe',
    height: '30px',
    paddingLeft: '10px',
    paddingTop: '10px',
    paddingBottom: '10px'
  },
  inputuserlogin: {
    marginLeft: theme.spacing(1),
    flex: 1,
    color: '#000',
    backgroundColor: '#e8f0fe',
    height: '30px',
    paddingLeft: '10px',
    paddingTop: '10px',
    paddingBottom: '10px'
  },
  ajustelogin: {
    color: '#000',
    width: '48px',
  },
  iconButton: {
    color: '#707070'
  },
  button: {
    width: '100%',
    backgroundColor: '#fff',
    color: '#2148C0',
    textTransform: 'uppercase',
    marginTop: '12%',
    paddingTop: '12px',
    paddingBottom: '12px'
  },
  link: {
    color: '#2148C0',
    textTransform: 'uppercase',
    textDecoration: 'none'
  },
  icon: {
    marginLeft: '10px',
    height: '48px',
    color: '#707070'
  },
  grid: {
    display: 'flex',
    flexDirection: 'column',
    backgroundImage: `url(${Background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    minHeight: '100vh',
    justifyContent: 'center',
    alignItems: 'center'
  },
  logo: {
    width: '20%',
    height: '20%'
  },
  form: {
    marginTop: '4%',
    width: '23%',
    display: 'flex',
    flexDirection: 'column'
  }
}))

export default useStyles
